/*************************************************/
/* 3rd Party                                     */
/*************************************************/
window.$ = window.jQuery = require("jquery");

/*************************************************/
/* Partials                                      */
/*************************************************/
import { intersectionObservation } from "./partials/intersectionObservation.js";
import { cookies } from "./partials/cookies.js";
import { news } from "./partials/news.js";
import { form } from "./partials/form.js";
import { header } from "./partials/header.js";
import { language } from "./partials/language.js";
import { search } from "./partials/search.js";
import { searchbar } from "./partials/searchbar.js";
import { modal } from "./partials/modal.js";

/*************************************************/
/* Global variables                              */
/*************************************************/
const $body = $("body"),
    bodyLoadingClass = "is-loading",
    currentCulture = $("html").attr("lang");

/*************************************************/
/* Init                                          */
/*************************************************/
const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    intersectionObservation();
    cookies();
    searchbar($body);
    header($body);
    language();
    search();
    modal($body, bodyLoadingClass);
    form(document.body, bodyLoadingClass);
    news($body, bodyLoadingClass, currentCulture);
});